(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('orderDialog', {
        templateUrl: 'views/components/views/orderDialog/orderDialog.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'utilityService', 'translateService', 'modalService', 'orderDialogService', function ($stateParams, utilityService, translateService, modalService, orderDialogService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let orderInternalNo = $stateParams.order_internal_no;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                edit: {},
                commentListOrders: [],
                lockedAdd: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEdit() {
                vm.model.edit = (await orderDialogService.getEdit({ order_internal_no: orderInternalNo }))[0];
            }

            async function loadDialogues() {
                if (utilityService.validateParmsValue(vm.model.edit.order_internal_no) !== true) return;

                return vm.model.commentListOrders = await orderDialogService.listDialogues({ order_internal_no: vm.model.edit.order_internal_no });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region BUTTON ADD PROCEDURE FUNCTION CALL

            vm.addChanges = function () {
                vm.model.lockedAdd = true;

                orderDialogService.addMessage(vm.model.edit).then(async function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedAdd = false;
                    			}
                    		}]
                    	});
                    } else {
                        vm.model.lockedAdd = false;

                        await loadEdit();
                        loadDialogues();
                    }
                });
            }

            // #endregion BUTTON ADD PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadEdit();
                loadDialogues();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
